import { Box, CircularProgress } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";
import type { FC } from "react";
import { useShowQuotation } from "../../../../../__generated__/orval/endpoints/quotations/quotations";
import { QuotationOffers } from "./-internal_components/QuotationOffers";

const RouteComponent: FC = () => {
  const { quotationId } = Route.useParams();

  const { data: quotation, isLoading } = useShowQuotation(Number(quotationId));

  if (isLoading || !quotation) {
    return (
      <Box
        sx={{ alignItems: "center", display: "flex", justifyContent: "center" }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <QuotationOffers quotation={quotation} quotationId={Number(quotationId)} />
  );
};

export const Route = createFileRoute(
  "/_private/vbuyer/quotations/$quotationId/offers",
)({
  component: RouteComponent,
});
